import { OwnershipLevel, PersonaType, WorkPackageStats } from '@bechtel/types';
import React, { Fragment, useEffect, useState } from 'react';
import { useAppUser } from '@bechtel/client-common';
import { FieldEngineerDashboardContent } from '~/field-engineer';
import { ForemanDashboardContent } from '~/foreman';
import { DashboardProgress } from '~/progress';
import { SuperIntendentDashboardContent } from '~/superintendent';
import { useDashboardPermissions } from '@bechtel/client-dashboard-common';
import { dashBoardStatsMock } from '../form-data';
import { useDashboardStatsQuery } from '~/hooks';
import { find } from 'lodash';

export const DashboardContent = ({ selectedCrewMember }) => {
  const { user } = useAppUser();
  const [getSelectedCrewMemberDashboardStats, result] = useDashboardStatsQuery();
  const { called, loading, data } = result;
  const [dashboardStats, setdashboardStats] = useState<WorkPackageStats>(dashBoardStatsMock);
  const crewMember = selectedCrewMember ? selectedCrewMember : user?.crewMember;
  const currentProjectWeek = find(user?.project?.projectConfiguration?.projectWeeks, (projectWeek) =>
    projectWeek?.isCurrent ? true : false
  );
  useEffect(() => {
    if (
      !user ||
      !crewMember ||
      !crewMember.id ||
      !crewMember.persona ||
      crewMember?.persona === PersonaType.SUPER_ADMIN
    )
      return;

    getSelectedCrewMemberDashboardStats({
      variables: {
        input: {
          crewMemberId: crewMember.id,
          personaType: crewMember.persona,
          ownershipLevel: OwnershipLevel.PRIMARY,
          startDate: currentProjectWeek?.startDate,
          endDate: currentProjectWeek?.endDate,
        },
      },
    });
  }, [user, crewMember, getSelectedCrewMemberDashboardStats]);

  useEffect(() => {
    data && data.workPackageStats
      ? setdashboardStats(data.workPackageStats)
      : setdashboardStats({ ...dashBoardStatsMock });
  }, [data]);

  const {
    canViewSuperIntendentDashboard,
    canViewForemanDashboard,
    canViewSuperAdminDashboard,
    canViewFieldEngineerDashboard,
  } = useDashboardPermissions();

  const { progress, plannedMilestones } = dashboardStats;
  const progressValues = {
    ...progress,
    targetHours: progress.committedHours > progress.approvedHours ? progress.committedHours : progress.approvedHours,
  };

  return (
    <Fragment>
      <DashboardProgress
        progress={
          crewMember && crewMember.persona && crewMember.persona === PersonaType.FIELD_ENGINEER
            ? progressValues
            : progress
        }
        showTargetIndicator={
          !!(
            crewMember &&
            crewMember.persona &&
            crewMember.persona !== PersonaType.FIELD_ENGINEER &&
            called &&
            !loading
          )
        }
        crewMember={crewMember}
        plannedMilestones={plannedMilestones}
      />
      {selectedCrewMember &&
        (selectedCrewMember.persona === PersonaType.SUPERINTENDENT ||
          selectedCrewMember.persona === PersonaType.GENERAL_FOREMAN) && (
          <SuperIntendentDashboardContent crewMember={selectedCrewMember} result={result} />
        )}
      {selectedCrewMember && selectedCrewMember.persona === PersonaType.FOREMAN && (
        <ForemanDashboardContent crewMember={selectedCrewMember} result={result} />
      )}
      {selectedCrewMember && selectedCrewMember.persona === PersonaType.FIELD_ENGINEER && (
        <FieldEngineerDashboardContent crewMember={selectedCrewMember} result={result} />
      )}

      {!selectedCrewMember &&
        (((canViewSuperIntendentDashboard || canViewSuperAdminDashboard) && (
          <SuperIntendentDashboardContent crewMember={user?.crewMember} result={result} />
        )) ||
          (canViewForemanDashboard && <ForemanDashboardContent crewMember={user?.crewMember} result={result} />) ||
          (canViewFieldEngineerDashboard && (
            <FieldEngineerDashboardContent crewMember={user?.crewMember} result={result} />
          )))}
    </Fragment>
  );
};
